"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Point {
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
    /**
     * Calculate the distance in pixels between this point and the given
     */
    distance(other) {
        const dx = (this.x - other.x) ** 2;
        const dy = (this.y - other.y) ** 2;
        return Math.round(Math.sqrt(dx + dy));
    }
}
Point.ZERO = new Point(0, 0);
exports.default = Point;
//# sourceMappingURL=Point.js.map